<template>
  <div class="content">
    <div class="top">
      <Swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <SwipeItem>
          <img
            style="width:100%"
            src="@/assets/msbIMG/bannner.jpg"
            alt=""
            srcset=""
          />
        </SwipeItem>
      </Swipe>
      <div class="modular">
        <div
          v-for="(modular, key) of modularList"
          :key="key"
          @click="jump(modular.moduleLink)"
          class="item"
        >
          <img class="icon" :src="modular.moduleIcon" alt="" />
          <div class="modularName">{{ modular.moduleName }}</div>
        </div>
      </div>
    </div>

    <van-dialog
      v-model="show"
      title="绑定手机号"
      show-cancel-button
      @confirm="confirm"
      confirm-button-text="立即绑定"
      confirm-button-color="#0587FE"
      cancel-button-color="#878787"
      :before-close="onBeforeClose"
    >
      <div class="dialogItem">
        <div class="label">手机号 <i></i></div>
        <input
          v-model="dialogFrom.mobileno"
          placeholder="请输入手机号"
          type="text"
        />
      </div>
      <div class="dialogItem">
        <div class="label">密码 <i></i></div>
        <input v-model="dialogFrom.pwd" placeholder="请输入密码" type="text" />
      </div>
      <div class="dialogItem dialogCode">
        <input
          v-model="dialogFrom.code"
          placeholder="请输入验证码"
          type="text"
        /><Button
          :disabled="isDisabled"
          @click="getCode"
          class="btn"
          type="info"
          >{{ sendName }}</Button
        >
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Dialog, Form, Field, Button, Toast } from "vant";
import md5 from "md5";
import Footer from "@/components/Footer";
import {
  BASEURL,
  GETALLBUSINESS,
  GETMETERLIST,
  SENDAUTHCODE,
  MOBILEBINDNO,
  MOBILEBINDCHECK,
} from "@/api/ApiConfig";
import { isWeiXin } from "@/utils/functionUtil";

export default {
  name: "home",
  components: {
    Swipe,
    SwipeItem,
    Footer,
    [Dialog.Component.name]: Dialog.Component,
    Form,
    Field,
    Button,
    Toast,
  },
  data() {
    return {
      show: false,
      modularList: [
        {
          moduleName: "户号绑定",
          moduleLink: "/householdBinding",
          moduleIcon: require("@/assets/msbIMG/huhaobanding.png"),
        },
        {
          moduleName: "缴纳水费",
          moduleLink: "/waterFeePayment",
          moduleIcon: require("@/assets/msbIMG/jiaonashuifei.png"),
        },
        {
          moduleName: "电子发票",
          moduleLink: "/Invoice",
          moduleIcon: require("@/assets/msbIMG/dianzifapiao.png"),
        },
      ],
      dialogFrom: {
        mobileno: "",
        pwd: "",
        code: "",
      },
      sendName: "获取验证码",
      timer: null,
      second: 60,
      isDisabled: false,
    };
  },
  async mounted() {
    this.getUserMeterList();
    this.getisShowbindPhone();
  },
  methods: {
    onBeforeClose(action, done) {
      if (action == "confirm") {
        return done(false);
      } else {
        return done();
      }
    },
    getisShowbindPhone() {
      if (!isWeiXin()) {
        this.$request({
          url: MOBILEBINDCHECK,
          baseURL: BASEURL,
          method: "post",
          params: {},
        }).then((res) => {
          if (res.message == "用户未绑定") {
            this.show = true;
          }
        });
      }
    },
    confirm() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(this.dialogFrom.mobileno)) {
        Toast("手机号格式不正确");
        return;
      }
      if (!this.dialogFrom.pwd) {
        Toast("请输入密码");
        return;
      }
      if (!this.dialogFrom.code) {
        Toast("请输入验证码");
        return;
      }
      this.$request({
        url: MOBILEBINDNO,
        baseURL: BASEURL,
        method: "post",
        params: {
          authCode: this.dialogFrom.code,
          mobileno: this.dialogFrom.mobileno,
          password: md5(this.dialogFrom.pwd),
          waterCorpId: 3,
        },
      }).then((res) => {
        if (!res.status) {
          this.show = false;
        }
        Toast(res.message);
      });
    },
    getCode() {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (!myreg.test(this.dialogFrom.mobileno)) {
        Toast("手机号格式不正确");
        return;
      }
      this.$request({
        url: SENDAUTHCODE,
        baseURL: BASEURL,
        method: "post",
        params: {
          type: 3,
          mobile: this.dialogFrom.mobileno,
        },
      }).then((res) => {
        if (!res.status) {
          this.timer = setInterval(() => {
            this.second--;
            this.sendName = this.second + "秒后重发";
            this.isDisabled = true;
            if (this.second < 0) {
              this.sendName = "获取验证码";
              this.isDisabled = false;
              this.second = 60;
              clearInterval(this.timer);
            }
          }, 1000);
          Toast.success(res.message);
        } else {
          Toast.fail(res.message);
        }
        console.log(res);
      });
    },
    jump(path) {
      this.$router.push({
        path,
      });
    },
    getUserMeterList() {
      this.$request({
        url: GETMETERLIST,
        baseURL: BASEURL,
        method: "post",
        params: {},
      }).then((res) => {
        sessionStorage.setItem("UserMeterList", JSON.stringify(res.data));
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  // background-color: #fff;
  // height: 100vh;
}
.top {
  width: 100%;
  height: auto;
}
.content {
  .modular {
    width: 95%;
    margin: auto;
    box-sizing: border-box;
    background-size: 100% 100%;
    padding: 0.3rem 0;
    box-sizing: border-box;
    margin-bottom: 0.3rem;
    display: flex;
    .item {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .modularName {
      font-size: 0.3rem;
      font-weight: 400;
      color: #000000;
      margin-top: 0.1rem;
    }
    .icon {
      width: 0.63rem;
      height: 0.63rem;
    }
  }
  .footerBanner {
    position: relative;
    img {
      width: 100%;
    }
    span {
      position: absolute;
      font-size: 0.4rem;
      font-family: lixukexingshu;
      color: #012a43;
      margin-left: 50%;
      margin-top: 13%;
      transform: translate(-50%);
    }
  }
}
.dialogItem {
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-top: 0.2rem;
  .label {
    width: 0.9rem;
    text-align: justify;
    font-size: 0.3rem;
    font-weight: 400;
    color: #000000;
    i {
      display: inline-block;
      width: 100%;
    }
  }
  input {
    border-radius: 0.08rem;
    border: 0.02rem solid #d7d7d7;
    width: 4rem;
    height: 0.68rem;
    margin-left: 0.2rem;
    padding-left: 0.2rem;
    box-sizing: border-box;
  }
}
.dialogCode {
  align-items: center;
  margin-bottom: 0.3rem;
  input {
    width: 2.64rem;
    margin-left: 0rem;
  }
  .btn {
    width: 2.22rem;
    height: 0.74rem;
    margin-left: 0.28rem;
  }
}
::v-deep .van-dialog__content {
  margin-top: 0.35rem;
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  font-size: 0.3rem;
  font-weight: 400;
  color: #878787;
}
</style>
